import { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
// import { signOut } from "firebase/auth";

import logo from "../../assets/logo.png";

import { useMobileNav } from "../../store/context/MobileNavContext.js";
import { BASE_GAP_CLASS, SITE_NAME } from "../../services/lib/constants.js";



// import Search from "../../component/header/Search.js";
import Button from "../../component/ui/Button.js";
import Heading from "../../component/ui/Heading.js";

function MobileNav() {
  const { isMenuOpen, closeMenu } = useMobileNav();
  const dispatch = useDispatch();
  const location = useLocation();


  useEffect(() => {
    isMenuOpen && closeMenu();
  }, [location.pathname]);

  const handleSignOut = () => {
    // signOut(auth);
    // dispatch(clearUserData());
  };

  return (
    <nav
      className={`fixed inset-0 bg-black -z-10 flex flex-col justify-start items-center transition-all p-6 pt-24
        ${
          isMenuOpen
            ? "opacity-1 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
    >
      <div
        className={`transition-all duration-500 flex flex-col w-full relative z-50 ${
          isMenuOpen
            ? "translate-y-0 delay-100 opacity-1"
            : "translate-y-60 delay-0 opacity-0"
        }`}
      >
        {/* <Heading as="h2">Search</Heading> */}
        {/* <Search /> */}
      </div>

      <div
        className={`transition-all duration-500 w-full my-4 ${
          isMenuOpen
            ? "translate-y-0 delay-200 opacity-1"
            : "translate-y-60 delay-0 opacity-0"
        }`}
      >
        <Heading as="h2">Navigazione</Heading>
        <ul
          className="m-0 flex flex-col gap-1.5 text-[1.7rem]"
          onClick={closeMenu}
        >
          <li>
            <NavLink to="/">Home</NavLink>
          </li>
          <li>
            <NavLink to="/search">Cerca</NavLink>
          </li>
          <li>
            <NavLink to="/continuewatching">Preferiti</NavLink>
          </li>
          <li>
            <NavLink to="/categoria">Categoria</NavLink>
          </li>

        </ul>
      </div>

      <div
        className={`transition-all duration-500 w-full ${
          isMenuOpen
            ? "translate-y-0 delay-300 opacity-1"
            : "translate-y-60 delay-0 opacity-0"
        }`}
      >
        <Heading as="h2">Utente</Heading>
        <div className="flex flex-col gap-4 items-start">
            <>
              <Button onClick={closeMenu}>
                <NavLink to="/profilo">Profilo</NavLink>
              </Button>
              {/* <Button onClick={handleSignOut} label="Sign out">
                <span>Uscita</span>
              </Button> */}
            </>
          
        </div>
      </div>

      <img
        src={logo}
         width="35"
        height="50"
        className={`absolute bottom-4 -right-4 -z-10 -rotate-12 transition-all duration-700 ${
          isMenuOpen ? "opacity-20 delay-200" : "opacity-0 delay-0"
        }`}
        alt={SITE_NAME}
        title={`${SITE_NAME} logo`}
      />
    </nav>
  );
}

export default MobileNav;
